import React, { useState, useRef, useEffect } from "react";
import CodeMirror from "@uiw/react-codemirror";
import { html as htmlLang } from "@codemirror/lang-html";
import { css as cssLang } from "@codemirror/lang-css";
import { javascript as jsLang } from "@codemirror/lang-javascript";
import "./HTMLCSSJavaScriptCodeEditorTerminal.css";

export default function HTMLCSSJavaScriptCodeEditorTerminal() {
  const iframeRef = useRef(null);

  const [htmlCode, setHtmlCode] = useState("<h1>Hello HTML</h1>");
  const [cssCode, setCssCode] = useState(
    "h1 { color: red; text-align:center; }"
  );
  const [jsCode, setJsCode] = useState("console.log('Running JS!');");

  // 🧠 RUN CODE FUNCTION
  const runCode = (html = htmlCode, css = cssCode, js = jsCode) => {
    const code = `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8" />
        <style>${css}</style>
      </head>
      <body>
        ${html}
        <script>
          try {
            ${js}
          } catch (e) {
            document.body.innerHTML += '<pre style="color:red;">' + e + '</pre>';
          }
        </script>
      </body>
      </html>`;
    if (iframeRef.current) {
      iframeRef.current.srcdoc = code;
    }
  };

  // 🚀 AUTO-RUN WHEN TryItButtonHTML SENDS CODE
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const raw = params.get("code");

    if (raw) {
      try {
        const decoded = decodeURIComponent(raw);
        const parsed = JSON.parse(decoded);

        if (parsed.html || parsed.css || parsed.js) {
          const h = parsed.html || "";
          const c = parsed.css || "";
          const j = parsed.js || "";

          setHtmlCode(h);
          setCssCode(c);
          setJsCode(j);

          // 🟢 Run the received code instantly
          setTimeout(() => runCode(h, c, j), 100);
          return;
        }
      } catch (err) {
        console.error("Error decoding code param:", err);
      }
    }

    // If no code param → run defaults
    runCode();
  }, []);

  return (
    <div className="html-css-js-container">
      {/* Header */}
      <div className="header">
        <h3>HTML • CSS • JavaScript Playground</h3>
        <button onClick={() => runCode()} className="run-button">
          ▶ Run
        </button>
      </div>

      {/* Editors */}
      <div className="editor-grid">
        <div className="editor-panel">
          <h4>HTML</h4>
          <CodeMirror
            value={htmlCode}
            height="200px"
            extensions={[htmlLang()]}
            onChange={(val) => setHtmlCode(val)}
          />
        </div>

        <div className="editor-panel">
          <h4>CSS</h4>
          <CodeMirror
            value={cssCode}
            height="200px"
            extensions={[cssLang()]}
            onChange={(val) => setCssCode(val)}
          />
        </div>

        <div className="editor-panel">
          <h4>JavaScript</h4>
          <CodeMirror
            value={jsCode}
            height="200px"
            extensions={[jsLang()]}
            onChange={(val) => setJsCode(val)}
          />
        </div>
      </div>

      {/* Output */}
      <div className="output-panel">
        <h4>Output:</h4>
        <iframe
          ref={iframeRef}
          title="Live Output"
          sandbox="allow-scripts allow-same-origin allow-modals"
          style={{
            width: "100%",
            height: "350px",
            border: "1px solid #ccc",
            borderRadius: "8px",
            background: "#fff",
          }}
        ></iframe>
      </div>
    </div>
  );
}
